<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-4 col-lg-4">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstretornos"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)" title="Alterar"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)" title="Excluir"><i class="fa fa-trash"></i></button>
                                        <button type="button" class="btn btn-primary btn-sm btn-opcrud btn-green ajt-btn" @click.prevent="mtddetalhes(item.row.id)" title="Informações do retorno"><i class="fa fa-info-circle"></i></button>
                                    </template>                                    
                                    <template slot="slot_situacao" slot-scope="item">
                                        <span v-if="parseInt(item.row.stretorno) === 0" class="badge badge-pill badge-primary" style="background: #646dd4;">Em edição</span>
                                        <span v-else class="badge badge-pill badge-primary" style="background: #5a956a;">Retorno baixado</span>
                                    </template>                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="slot_conta" slot-scope="item">
                                        <span>{{ mtdformatarzeros(item.row.idconta, 2) }} - {{ item.row.descconta }}</span>
                                    </template>                                    
                                    <template slot="slot_banco" slot-scope="item">
                                        <span>{{ mtdformatarzeros(item.row.idbanco, 2) }} - {{ item.row.descbanco }}</span>
                                    </template>                                    
                                    <template slot="slot_totalcobranca" slot-scope="item">
                                        <span style="color: #5a956a; font-weight: 700;">{{ mtdformatavalordecimal(item.row.totalretorno, 2) }}</span>
                                    </template>                                    
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstretornos.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-5">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtpag">Dt. Pagamento:</label>
								<div class="input-group">
									<date-picker id="eddtpag" v-model="vdtpagamentobol" :config="options" class="form-control form-control-sm" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-3">
								<label for="cbconta">*Conta bancária:</label>
								<select id="cbconta" v-model="vidconta" v-bind:disabled="ativadesativa"
										data-placeholder="Selecione uma opção" data-allow-clear="true"
										style="width:100%;">
								</select>
							</div>
                            <template v-if="parseInt(vapibancocb) > 0">
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <button type="button" @click.prevent="mtdbuscaboletosapi()" class="btn btn-primary btn-sm btn-block"
                                            style="margin-top: 20px;" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-cloud-download"></i> Buscar boletos
                                    </button>
                                </div> 
                                <div class="col-sm-12 col-md-5 col-lg-5 dvnomearquivo2">
                                    <h5 style="color: #757b81; font-size: 15px;"> </h5>
                                </div>      
                            </template>
                            <template v-else>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <input type="file" id="btselecionaretorno" accept=".ret, .crt" style="display: none;">
                                    <button type="button" @click.prevent="mtdarquivoretorno()" class="btn btn-primary btn-sm btn-block"
                                            style="margin-top: 20px;" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-file"></i> Selecionar arquivo
                                    </button>
                                </div> 
                                <div class="col-sm-12 col-md-5 col-lg-5 dvnomearquivo">
                                    <h5 style="color: #757b81; font-size: 15px;">Arquivo: {{ vnomearquivoretorno }}</h5>
                                </div>      
                            </template>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbperfilfluxo">Perfil fluxo:</label>
								<select id="cbperfilfluxo" v-model="vidperfilfluxo" :disabled="parseInt($store.state.usuario.operaperfilfluxo)===0||ativadesativa" 
										data-placeholder="Selecione uma opção" data-allow-clear="true"
										style="width:100%;">
								</select>
                            </div>      
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <button type="button" @click.prevent="mtdmudaperfilfluxo()" class="btn btn-primary btn-sm btn-block"
                                        style="margin-top: 20px;" v-bind:disabled="parseInt(opcrud) === 3"> Aplicar
                                </button>
                            </div>                 
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflsttitulos" 
                                        :rows="lsttitulosret"
                                        :columns="columnstitret"
                                        :config="configtitret"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="slot_sttit" slot-scope="item">
                                        <span v-if="item.row.sttit === 'A'" class="badge badge-pill badge-danger" style="background: #646dd4;">ABERTO</span>
                                        <span v-else-if="item.row.sttit === 'B'" class="badge badge-pill badge-primary" style="background: #5a956a;">BAIXADO</span>
                                        <span v-else class="badge badge-pill badge-danger">PENDENTE</span>                                        
                                    </template>                                    
                                    <template slot="slot_codtit" slot-scope="item">
                                        <span v-if="item.row.sttit === 'N'" class="badge badge-pill badge-primary" style="background: #6c757d;">{{ item.row.codtit }}</span>
                                        <span v-else class="badge badge-pill badge-primary" style="background: #5a956a;">{{item.row.codtit}}</span>
                                    </template>
                                    <template slot="slot_cliente" slot-scope="item">
                                        <span v-if="item.row.idcliente !== '' && parseInt(item.row.idcliente) > 0">{{ mtdformatarzeros(item.row.idcliente, 6) }} - {{ item.row.nomecliente }}</span>
                                        <span v-else></span>
                                    </template>
                                    <template slot="slot_atraso" slot-scope="item">
                                        <template v-if="item.row.atraso !== ''">
                                            <span v-if="parseInt(item.row.atraso) > 0" class="badge badge-pill badge-danger">{{ item.row.atraso }}</span>
                                            <span v-else></span>
                                        </template>
                                        <template v-else>
                                            <span></span>
                                        </template>                                        
                                    </template>                                     
                                    <template slot="slot_valor" slot-scope="item">
                                        <span v-if="item.row.vlresta !== ''" style="color: #2f3c48; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlresta), 2) }}</span>
                                        <span v-else></span>
                                    </template>
                                    <template slot="slot_vlr_juros_multa" slot-scope="item">
                                        <span style="color: #6c757d; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlr_juros_multa), 2) }}</span>
                                    </template>                                                                                                                                                 
                                    <template slot="slot_valorrecebido" slot-scope="item">
                                        <span style="color: #5a956a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.valorrecebido), 2) }}</span>
                                    </template>                                                                            
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <ul class="list-group">                                    
                                    <a class="list-group-item lstdettot">Total do retorno <span class="badge badge-success">{{ lsttitulosret.length }}</span>: <span class="badge badge-primary bdg-totais">{{ mtdformatavalordecimal(vtotalretorno, 2) }}</span></a>
                                </ul>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <ul class="list-group">
                                    <a class="list-group-item lstdettot">Total à baixar <span class="badge badge-success">{{ qtdbaixar }}</span>: <span class="badge badge-info bdg-totais" style="background: #5A956A;">{{ mtdformatavalordecimal(vtotalbaixar, 2) }}</span></a>
                                </ul>
                            </div>                                                        
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal para visualização dos detalhes do retorno -->
        <div class="modal fade" id="mddetretorno">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title">Detalhes do retorno nº: {{ mtdformatarzeros(retornodetalhes.id, 7) }}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-7 col-lg-7">
                                <label for="eddetretdesc">Descrição:</label>
                                <input type="text" v-model="retornodetalhes.descricao" class="form-control form-control-sm" id="eddetretdesc" maxlength="50"
                                    style="text-transform: uppercase;" disabled>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="eddetconta">Conta:</label>
                                <input type="text" class="form-control form-control-sm" id="eddetconta" maxlength="50" v-bind:value="retornodetalhes.idconta+' - '+retornodetalhes.descconta"
                                    style="text-transform: uppercase;" disabled>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddetretemissao">Emissão:</label>
                                <input type="text" v-model="retornodetalhes.dtemissao" class="form-control form-control-sm" id="eddetretemissao" maxlength="50"
                                    style="text-transform: uppercase; text-align: right;" disabled>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflsttitulosdet" 
                                        :rows="titulosdetalhesret"
                                        :columns="columnstitretview"
                                        :config="configtitretview"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="slot_sttit" slot-scope="item">
                                        <span v-if="item.row.sttit === 'A'" class="badge badge-pill badge-danger" style="background: #646dd4;">ABERTO</span>
                                        <span v-else-if="item.row.sttit === 'B'" class="badge badge-pill badge-primary" style="background: #5a956a;">BAIXADO</span>
                                        <span v-else class="badge badge-pill badge-danger">PENDENTE</span>                                        
                                    </template>                                    
                                    <template slot="slot_codtit" slot-scope="item">
                                        <span v-if="item.row.sttit === 'N'" class="badge badge-pill badge-primary" style="background: #6c757d;">{{ item.row.codtit }}</span>
                                        <span v-else class="badge badge-pill badge-primary" style="background: #5a956a;">{{item.row.codtit}}</span>
                                    </template>
                                    <template slot="slot_cliente" slot-scope="item">
                                        <span v-if="item.row.idcliente !== '' && parseInt(item.row.idcliente) > 0">{{ mtdformatarzeros(item.row.idcliente, 6) }} - {{ item.row.nomecliente }}</span>
                                        <span v-else></span>
                                    </template>
                                    <template slot="slot_atraso" slot-scope="item">
                                        <template v-if="item.row.atraso !== ''">
                                            <span v-if="parseInt(item.row.atraso) > 0" class="badge badge-pill badge-danger">{{ item.row.atraso }}</span>
                                            <span v-else></span>
                                        </template>
                                        <template v-else>
                                            <span></span>
                                        </template>                                        
                                    </template>                                     
                                    <template slot="slot_valor" slot-scope="item">
                                        <span v-if="item.row.vlresta !== ''" style="color: #2f3c48; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlresta), 2) }}</span>
                                        <span v-else></span>
                                    </template>
                                    <template slot="slot_vlr_juros_multa" slot-scope="item">
                                        <span style="color: #6c757d; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlr_juros_multa), 2) }}</span>
                                    </template>                                                                                                                                                 
                                    <template slot="slot_valorrecebido" slot-scope="item">
                                        <span style="color: #5a956a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.valorrecebido), 2) }}</span>
                                    </template>                                                                            
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <ul class="list-group">                                    
                                    <a class="list-group-item lstdettot">Total do retorno <span class="badge badge-success">{{ titulosdetalhesret.length }}</span>: <span class="badge badge-primary bdg-totais">{{ mtdformatavalordecimal(vtotalretorno, 2) }}</span></a>
                                </ul>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <ul class="list-group">
                                    <a class="list-group-item lstdettot">Total à baixar <span class="badge badge-success">{{ qtdbaixar }}</span>: <span class="badge badge-info bdg-totais" style="background: #5A956A;">{{ mtdformatavalordecimal(vtotalbaixar, 2) }}</span></a>
                                </ul>
                            </div>                                                                                           
                        </div>
                    </div>
                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <div class="container" style="padding-left: 0px; padding-right: 0px;">
                            <div class="row">
                                <div class="col-sm-12 col-md-8 col-lg-8">
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 8px;">
                                    <a v-if="parseInt(retornodetalhes.stretorno) === 0" href="#" class="btn btn-primary btn-sm btn-green" role="button" @click.prevent="mtdconfirmarbaixa()" style="width:100%; margin-top: 2px;"><i class="fa fa-check"></i> Baixar retorno</a>
                                </div>                                
                                <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 8px;">
                                    <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal" style="width:100%; margin-top: 2px;"><i class="fa fa-close"></i> Cancelar</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadretornosbancarios',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstretornos  : [],
                pfiltro      : 1,
                pconteudo    : '',
				pfiltroperiodo      : 1,
				pdtini       		: util.DataAtual(true),
				pdtfim       		: util.DataAtual(true),				                
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,


                //variáveis do crud
                opcrud              :  0,
                lsttitulosret       : [],
                vid                 : '',
                vdescricao          : '',
                vidconta            : null,
                vapibancocb         : 0,
                vtotalretorno       : 0,
                vtotalbaixar        : 0,
                qtdbaixar           : 0,
                vnomearquivoretorno : '',
                vdtpagamentobol     : util.DataAtual(true),

                //variável para habilitação dos campos
                ativadesativa       : true,

                //variaveis alteração perfil fluxo

                vidperfilfluxo      : null,
                //variáveis para visualização dos detalhes da cobrança
                retornodetalhes     : [],
                titulosdetalhesret  : [],

                options: {
                    format          : 'DD/MM/YYYY',
                    useCurrent      : false,
                    locale          : 'pt-BR'
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'RETORNOS BANCÁRIOS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-ret",
                        sort: false
                    },
                    {
                        label: "Situação",
                        name: "stretorno",
                        sort: true,
                        slot_name: "slot_situacao",
                        row_classes: "def-col-situacao",
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Emissão",
                        name: "dtemissao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Conta",
                        name: "descconta",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_conta",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Banco",
                        name: "descbanco",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_banco",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Arquivo",
                        name: "nomearquivo",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Total retorno",
                        name: "totalretorno",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_totalretorno",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    }                    
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                columnstitret: [
                    {
                        label: "Nosso número",
                        name: "nossonumero",
                        sort: true
                    },
                    {
                        label: "",
                        name: "sttit",
                        slot_name: "slot_sttit",
                        sort: true
                    },                    
                    {
                        label: "Nr. Título",
                        name: "codtit",
                        slot_name: "slot_codtit",
                        sort: true
                    },                    
                    {
                        label: "Cliente",
                        name: "nomecliente",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_cliente",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Emissão",
                        name: "dtemitit",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Vencimento",
                        name: "dtventit",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Valor do título",
                        name: "vlresta",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_valor",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Dt. Pagamento",
                        name: "datapagamento",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Atraso",
                        name: "atraso",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        slot_name: "slot_atraso",
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Vl. Juros/Multa",
                        name: "vlr_juros_multa",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_vlr_juros_multa",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Valor Pago",
                        name: "valorrecebido",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_valorrecebido",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Observações",
                        name: "obstit",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Perfil fluxo",
                        name: "perfilfluxo",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],                
                configtitret: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                columnstitretview: [
                    {
                        label: "Nosso número",
                        name: "nossonumero",
                        sort: true
                    },
                    {
                        label: "",
                        name: "sttit",
                        slot_name: "slot_sttit",
                        sort: true
                    },                    
                    {
                        label: "Nr. Título",
                        name: "codtit",
                        slot_name: "slot_codtit",
                        sort: true
                    },                    
                    {
                        label: "Cliente",
                        name: "nomecliente",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_cliente",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Emissão",
                        name: "dtemitit",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Vencimento",
                        name: "dtventit",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Valor do título",
                        name: "vlresta",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_valor",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Dt. Pagamento",
                        name: "datapagamento",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Atraso",
                        name: "atraso",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        slot_name: "slot_atraso",
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Vl. Juros/Multa",
                        name: "vlr_juros_multa",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_vlr_juros_multa",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Valor Pago",
                        name: "valorrecebido",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_valorrecebido",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Observações",
                        name: "obstit",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Perfil fluxo",
                        name: "perfilfluxo",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],                
                configtitretview: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },                                   
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdmudaperfilfluxo(){ //guga
                if(parseInt(this.$store.state.usuario.operaperfilfluxo)===0){
                    this.$toastr.i('Seu usuário não esta habilitado a operar perfil de fluxo!', 'Informação!');
                    return;
                }
                if(this.vidperfilfluxo==null){
                    this.$toastr.i('informe o perfil de fluxo!', 'Informação!');
                }
                for (let i = 0; i <  this.$refs.reflsttitulos.selected_items.length; i++) {
                    let indice = util.getArrayIndexForKey(this.lsttitulosret, 'codreg', this.$refs.reflsttitulos.selected_items[i].codreg);
                    this.lsttitulosret[indice].idperfilfluxo = this.vidperfilfluxo
                    this.lsttitulosret[indice].perfilfluxo = $("#cbperfilfluxo").select2('data')[0]['text']
                }
                $("#cbperfilfluxo").val(null).trigger('change');
                this.$refs.reflsttitulos.unSelectAllItems();
            },
			mtdformatavalordecimal(valor, digitos){
				try {
					return util.formatavalordecimais(valor, digitos);
				}
				catch (e) {
					return 0;
				}                
			},            
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},             
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and r.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(r.descricao) like upper("'+this.pconteudo+'%")';
                }
				if(parseInt(this.pfiltroperiodo) === 1){
					rfiltro = rfiltro + ' and r.dtemissao between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
				}                                              
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadretornosbancarios.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregaretornos(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregaretornos(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadretornosbancarios.php');
                retorno.then(function (response) {
                    vself.lstretornos = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstretornos = [];
                    loader.hide();
                });
            },
			mtdselect2_def(){
				let vself  = this;
				$("#cbconta").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbcontasbancarias',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidconta            = $("#cbconta").val();   
                    vself.lsttitulosret       = [];
                    vself.vnomearquivoretorno = '';
                    vself.mtdcalcularretorno(vself.lsttitulosret);

                    if (vself.vidconta != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'op',           valor : 'pegadadosbanco'},
                            {parametro: 'idconta',      valor : vself.vidconta},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadretornosbancarios.php');
                        retorno.then(function (response) {
                            vself.vapibancocb = response.data.apibanco;
                            console.log(vself.vapibancocb)
                            loader.hide();
                        }).catch(function (response) {
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.vapibancocb = 0;
                    }					
                });
                $("#cbperfilfluxo").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbperfisfluxocaixa',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                  
                    vself.vidperfilfluxo = $("#cbperfilfluxo").val();                    
                });
                $('#btselecionaretorno').change(function() {
                    vself.mtdrotinaretorno();
                });                
			},            
            resetarDados() {
                util.toTop();

                this.lsttitulosret      = [];
                this.vid                = '';
                this.vdescricao         = '';
                this.vidconta           = null;
                this.vtotalretorno      = 0;
                this.vtotalbaixar       = 0;
                this.qtdbaixar          = 0;                
                this.vdtpagamentobol    = util.DataAtual(true);                

                $('#cbconta').val(null).trigger('change');

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('030Z.030Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE RETORNO BANCÁRIO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstcobrancas = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and r.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadretornosbancarios.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(response.data[0].stretorno) === 1 ){
                        vself.$toastr.i('Retorno já baixado, impossível realizar esta operação!', 'Informação!');
                        vself.mtdcancelaredicao();
                        return;
                    }
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('030Z.030Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE COBRANÇAS BANCÁRIAS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('030Z.030Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                        
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE RETORNOS BANCÁRIOS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                    this.configtitcob.checkbox_rows = false;
                }
            },
            mtdigualarcampos(registro){
                this.vid                 = registro.id;
                this.vdescricao          = registro.descricao;                                

                var defconta  = new Option(registro.descconta, registro.idconta, true, true);
                $('#cbconta').append(defconta).trigger('change');             

                this.vnomearquivoretorno = registro.nomearquivo;                           
                this.vtotalretorno       = registro.totalretorno;
                this.lsttitulosret       = registro.titulos;  
                this.mtdcalcularretorno(this.lsttitulosret);
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'descricao'         : this.vdescricao,
                    'dtpagamento'       : this.vdtpagamentobol,
                    'idconta'           : this.vidconta,
                    'nomearquivo'       : this.vnomearquivoretorno,
                    'totalretorno'      : this.vtotalretorno,                    
                    'titulos'           : this.lsttitulosret
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '030Z.020Z.010Z' : parseInt(this.opcrud) === 2 ? '030Z.020Z.020Z' : '030Z.020Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadretornosbancarios.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltroperiodo= 0;
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregaretornos(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtddetalhes(idretorno){
                var vself       = this;
                if (!util.opcaousuario('030Z.030Z.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else{                          
                    let loader      = vself.$loading.show();
                    let filtro      = ' and r.id='+idretorno;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadretornosbancarios.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.retornodetalhes       = response.data[0];
                        vself.titulosdetalhesret    = vself.retornodetalhes.titulos;
                        vself.mtdcalcularretorno(vself.titulosdetalhesret);
                        $('#mddetretorno').modal('show');
                    }).catch(function (response) {
                        loader.hide();
                    });                        
                }
            },
            mtdcalcularretorno(lsttitulos) {
                this.vtotalretorno     = 0;
                this.vtotalbaixar      = 0;
                this.qtdbaixar         = 0;
                for (var i = 0; i < lsttitulos.length; i++) {
                    this.vtotalretorno = this.vtotalretorno + parseFloat(lsttitulos[i].valorrecebido);
                }
                for (var x = 0; x < lsttitulos.length; x++) {
                    if (lsttitulos[x].sttit === "A") {
                        this.vtotalbaixar = this.vtotalbaixar + parseFloat(lsttitulos[x].valorrecebido);
                        ++this.qtdbaixar;
                    }
                }
            },            
            mtdarquivoretorno() {
                if (this.vidconta === null){
                    this.$toastr.w("Informe a conta para processamento do arquivo de retorno!", 'Atenção!');
                    $("#cbconta").focus();
                    return;
                }
                //limpa o arquivo do input file
                const file               = document.querySelector('#btselecionaretorno');
                file.value               = '';
                this.vnomearquivoretorno = '';
                this.lsttitulosret       = [];
                this.mtdcalcularretorno(this.lsttitulosret);
                ///////////////////////////////
                $('#btselecionaretorno').trigger('click');
            },
            mtdbuscaboletosapi(){
                let vself = this;
                let loader      = vself.$loading.show();

                let parametros      = [
                        {parametro: 'op',           valor : 'buscaboletosapi'},
                        {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'idconta',      valor : vself.vidconta},
                        {parametro: 'dtpagamento',  valor : vself.vdtpagamentobol}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadretornosbancarios.php');
                retorno.then(function (response) {
                    if (!response.data.ret){
                        vself.lsttitulosret = response.data.lstretorno;
                        vself.mtdcalcularretorno(vself.lsttitulosret);
                    }else{
                        let tpret = response.data.ret.substring(0,1);
                        // console.log(tpret)
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.ret.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.ret.substring(4), 'Erro!');
                                break;
                        }
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdrotinaretorno(){
                let vself = this;                
                
                let varquivoretorno         = document.getElementById("btselecionaretorno").files[0];
                vself.vnomearquivoretorno   = varquivoretorno.name;

                let extarq = varquivoretorno.name.substring(varquivoretorno.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'RET' && extarq.toUpperCase() !== 'CRT'){
                    vself.$toastr.w("O arquivo de retorno selecionado não é um arquivo válido!", 'Atenção!');
                    vself.lsttitulosret = [];
                    vself.mtdcalcularretorno(vself.lsttitulosret);
                }else{ 
                    let loader      = vself.$loading.show();
                    let localsalvar = vself.$store.state.configpaths.pathretornos + vself.$store.state.filialpadrao.idcliente;

                    let parametros      = [
                        {parametro: 'arquivo',          valor  : varquivoretorno},
                        {parametro: 'localsalvar',      valor  : localsalvar},
                        {parametro: 'nomearquivo',      valor  : varquivoretorno.name}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                    retorno.then(function (response) {
                        if ($.isNumeric(response.data.inf)){
                            $('#btselecionaretorno').val('');
                            vself.mtdprocessararquivoretorno(vself.$store.state.configpaths.pathretornos + vself.$store.state.filialpadrao.idcliente+'/'+vself.vnomearquivoretorno, vself.vidconta)
                        }else{
                            $('#btselecionaretorno').val('');
                            vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                        }
                        loader.hide();
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                        $('#btselecionaretorno').val('');
                    });
                }
            },
            mtdprocessararquivoretorno(arquivo, idconta){
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'processararquivo'},
                    {parametro: 'arquivo',      valor : arquivo},
                    {parametro: 'idconta',      valor : idconta},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadretornosbancarios.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.ret)){
                        if (parseInt(response.data.ret) === 0){
                            vself.lsttitulosret = response.data.lstretorno;
                            vself.mtdcalcularretorno(vself.lsttitulosret);
                        }else{
                            vself.$toastr.w('Arquivo de retorno não pertence a conta informada!', 'Atenção!');
                            $('#cbconta').focus();
                        }
                    }else{
                        vself.$toastr.e(response.data.ret, 'Erro!');
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },            
            mtdconfirmarbaixa(){
                let vself = this;                
                if (!util.opcaousuario('030Z.030Z.050Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma baixa do retorno bancário?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    let loader = vself.$loading.show();                                        
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',           valor : 'baixartitulos'},
                                        {parametro: 'opcrud',       valor : vself.opcrud},
                                        {parametro: 'idretorno',    valor : vself.retornodetalhes.id},
                                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',        valor : '030Z.030Z.050Z'},
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadretornosbancarios.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            $('#mddetretorno').modal('hide');
                                            vself.$toastr.s('Títulos baixados com sucesso!', 'Informação!');
                                            vself.pfiltroperiodo= 0;
                                            vself.pfiltro       = 0;
                                            vself.pconteudo     = vself.retornodetalhes.id;
                                            vself.pqtd_paginas  = 1;
                                            vself.mtdcancelaredicao();
                                            vself.mtdcarregaretornos(1);
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                }
                            }
                        }
                    });
                }      
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (parseInt(vself.$store.state.filialpadrao.plnc) < 2){
                        vself.$swal.fire({
                                            position: 'bottom-end',
                                            //icon: 'success',
                                            title: 'Atenção!',
                                            html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
                                            showConfirmButton: false,
                                            showCloseButton: true,
                                            backdrop: false                                                
                                        }); 
                        setTimeout(function(){
                            util.gotoprincipal();
                        },4000);                                                               
                    }                     
                    if (util.opcaousuario('030Z.030Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdexecutapesquisa();
                        vself.mtdselect2_def();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescricao === '' || this.vidconta === null || this.lsttitulosret.length === 0;
            },
            selecionaperiodo: function () {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregaretornos(val);
            }        
        }
    }
</script>
<style>
    .dvnomearquivo{
        margin-top: 20px;
        border: 1px solid #ced4da;
        padding-top: 5px;
        height: 30px;
        border-radius: 4px;
        margin-left: 15px;
        margin-right: 15px;
    }
    .dvnomearquivo2{
        margin-top: 20px;
        padding-top: 5px;
        height: 30px;
        border-radius: 4px;
        margin-left: 15px;
        margin-right: 15px;
    }
    .def-col-opcoes-ret{
        width: 140px !important;
    }
    .def-col-cod{
        width: 80px !important;
    }
    .def-col-situacao{
        width: 100px !important;
    }
    .def-col-opcoes-dt{
        width: 40px !important;
    } 
</style>